/* STEIN & VOSS — Empfehlungen: per-visit shuffle (client-side, no caching issues) */
(function () {
  'use strict';
  if (window.__svEmpInitialized) return;
  window.__svEmpInitialized = true;

  function init(section) {
    var grid = section.querySelector('.sv-emp__grid');
    if (!grid) return;
    if (grid.classList.contains('is-ready')) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-sv-emp-item]'));
    var pool = grid.querySelector('template[data-sv-emp-pool]');
    if (pool) items.push.apply(items, Array.prototype.slice.call(pool.content.querySelectorAll('[data-sv-emp-item]')));
    var show = parseInt(section.getAttribute('data-sv-emp-show'), 10) || 8;
    if (items.length <= show) {
      grid.classList.add('is-ready');
      return;
    }

    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }

    var selected = document.createDocumentFragment();
    items.slice(0, show).forEach(function (item) { selected.appendChild(item); });
    grid.replaceChildren(selected);

    grid.classList.add('is-ready');
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-sv-emp]').forEach(init);
  });

  function boot() {
    document.querySelectorAll('[data-sv-emp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
